import React, { PropsWithChildren, useEffect } from "react";
import { useSideBar } from "./AppLayout";

export interface SideBarProps {
  isVisible: boolean;
}

export const SideBar: React.FC<PropsWithChildren<SideBarProps>> = ({
  isVisible,
  children
}) => {
  const { sideBarContent, setSideBarContent, setIsSideBarVisible } =
    useSideBar();

  useEffect(() => {
    setSideBarContent(children);
    setIsSideBarVisible(isVisible);

    return () => {
      setSideBarContent(undefined);
      setIsSideBarVisible(false);
    };
  }, [isVisible, children]);

  return null;
};
